import { Component, OnInit } from '@angular/core';
import { CheckoutService } from '../../providers/checkout.service';
import { Submitted_entries_receipt } from '../../models/submitted_entries_receipt';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-entries-receipt',
  templateUrl: './entries-receipt.component.html',
styleUrls:  ['./entries-receipt.component.css']
})
export class EntriesReceiptComponent  extends SmsAbstractAppPage implements OnInit {

	receipt: Submitted_entries_receipt = new Submitted_entries_receipt({});

  constructor(private checkoutService: CheckoutService) {
  	super();
  }

  ngOnInit() {
  	this.checkoutService.getSubmitted_entries_receipt().subscribe(receipt => {
  		this.receipt = receipt;
  	}, error => {
  		this.handleError(error);
  	});
  }

}
